// Copyright 2021 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { SoramaPortalDb } from "libraries/IndexedDb/SoramaPortalDb";
import { GenericIndexedDBRepository } from "repositories/GenericRepository";
import { LocalDatabaseImage } from "services/Image/LocalImageService";

@autoinject
export class LocalImageRepository extends GenericIndexedDBRepository<LocalDatabaseImage> {
    constructor(indexedDb: SoramaPortalDb) {
        super(indexedDb, SoramaPortalDb.LocalImageStoreName);
    }

    protected fromDatabase(obj: LocalDatabaseImage): LocalDatabaseImage {
        return obj;
    }
}
